import React from 'react';
import {connect} from 'react-redux';
import style from './style.css';
import CompanyModel from '/app/src/model/Company/model';
import * as CompanySelectors from '/app/src/model/Company/selector';
import {SVGButton, Jibber, H3, TextInput, Flex} from '/app/src/component';
import {ButtonBarLayout} from '/app/src/layoutComponent'
import {history} from '/app/src/store'

class CompanyPayment extends Jibber{
    constructor(props){
        super(props);

        this.useState({
            isPrivate: false,
            companyName: this.props.companyName,
            address: this.props.address,
            email: this.props.email,
            city: this.props.city,
            orgNumber: this.props.orgNumber,
            postalCode: this.props.postalCode,
            country: 'Sweden',
            referenceName: this.props.referenceName,
            referenceEmail: this.props.referenceEmail,
            period: this.props.period
        })
        this._handleChange = this._handleChange.bind(this);
        this._onButtonClick = this._onButtonClick.bind(this);
        this._handleRadioButtons = this._handleRadioButtons.bind(this);
    }

    componentDidMount(){
        this.props.dispatch(CompanyModel.billingRead());
    }

    componentWillReceiveProps(nextProps){
        this.setState({
            isPrivate: false,
            companyName: nextProps.companyName,
            address: nextProps.address,
            email: nextProps.email,
            city: nextProps.city,
            orgNumber: nextProps.orgNumber,
            postalCode: nextProps.postalCode,
            country: 'Sweden',
            referenceName: nextProps.referenceName,
            referenceEmail: nextProps.referenceEmail,
            changed: false,
            period: nextProps.period
        })
    }

    render() {
        const cancelJibberStyle = {
            hAlignContent: 'center',
            textDecoration: 'underline',
            color: '#0000EE',
            padding: '10px 0px',
            cursor: 'pointer'
        }
        return <Flex width='100%' h='100%' column>
                <ButtonBarLayout>
                    <Flex column>
                        <SVGButton disabled={!this.state.changed} text='Spara' src='/images/Save.svg' onClick={this._onButtonClick} border color='black' hover='blue'/>
                        <Flex h='10px' fontSize='12px' fontWeight='400' color='darkgrey' mt='2px'>
                            { this.state.changed && '*Ändringar är inte sparade'}
                        </Flex>
                    </Flex>
                </ButtonBarLayout>

                <Flex width='100%' overflowY='auto' hAlignContent='center'>
                    <Flex column shrink={0} width='70%'>
                        {this._renderInformationForms()}
                    </Flex>
                </Flex>

                <Flex
                    onClick = {() => history.push({
                            pathname: '/companySettings/endSubscription',
                        })}
                    {...cancelJibberStyle}>
                    Avsluta Jibber-konto
                </Flex>
            </Flex>
    }

    _handleChange(event){
        this.setState({[event.target.name]: event.target.value, changed: true})
    }

    _handleRadioButtons(bool){
        this.setIsPrivate(bool)
    }
    _onButtonClick(){
        const hasInfo = this.props.hasInfo;
        if(hasInfo){
            this.props.dispatch(CompanyModel.billingPut(
                this.state.isPrivate,
                this.state.companyName,
                this.state.address,
                this.state.email,
                this.state.city,
                this.state.orgNumber,
                this.state.postalCode
            ));
        }else{
            this.props.dispatch(CompanyModel.billingPost(
                this.state.isPrivate,
                this.state.companyName,
                this.state.address,
                this.state.email,
                this.state.city,
                this.state.orgNumber,
                this.state.postalCode
            ));
        }
    }

    _renderRadioButtons(){
        return(
            <Flex hAlignContent='center'>
                <p className={style.TextStyle}>Företag</p>
                <input className={style.RadioCompany} type="radio" name='radioButton' onChange={() => {this._handleRadioButtons(false)}} checked={this.state.isPrivate === false}/>
                <p className={style.TextStyle}>Privatperson</p>
                <input className={style.RadioPerson} type="radio" name='radioButton' onChange={() => {this._handleRadioButtons(true)}} checked={this.state.isPrivate === true}/>
            </Flex>
        );
    }

    _renderInformationForms(){
        let name = 'Namn'
        return(
            <Flex hAlignContent='center' width='100%' wrap>
                    <Flex hAlignContent='center' basis='250px' column className={style.InformationFormsContainer}>
                        <Flex w='90%' column>
                            <H3 marginBottom='5px'> {name} </H3>
                            <TextInput placeholder={name} onChange={this._handleChange} autoComplete='organization' value={this.state.companyName} name='companyName'/>
                            <H3 marginBottom='5px' marginTop='20px'> E-post </H3>
                            <TextInput placeholder='E-post' onChange={this._handleChange} autoComplete='email' value={this.state.email} name='email'/>
                            <H3 marginBottom='5px' marginTop='20px'> Organisationsnummer / Personnumer </H3>
                            <TextInput placeholder='Organisationsnummer' label='Organisationsnummer/Personsnummer' onChange={this._handleChange} autoComplete='organization' value={this.state.orgNumber} name='orgNumber'/>
                        </Flex>
                    </Flex>
                    <Flex hAlignContent='center' basis='250px' column className={style.InformationFormsContainer}>
                        <Flex w='90%' column>
                            <H3 marginBottom='5px'> Adress </H3>
                            <TextInput placeholder='Adress' onChange={this._handleChange} autoComplete='address-line1' value={this.state.address} name='address'/>
                            <H3 marginBottom='5px' marginTop='20px'> Stad </H3>
                            <TextInput placeholder='Stad' label='Stad' onChange={this._handleChange} autoComplete='address-level2' value={this.state.city} name='city'/>
                            <H3 marginBottom='5px' marginTop='20px'> Postnummer</H3>
                            <TextInput placeholder='Postnummer' label='Postnummer' onChange={this._handleChange} autoComplete='postal-code' value={this.state.postalCode} name='postalCode'/>
                            <H3 marginBottom='5px' marginTop='20px'> Land</H3>
                            <select name="country" className={style.FormStyleRight} style={{width: '230px'}} autoComplete='address-level1'>
                                <option value="sweden">Sverige</option>
                            </select>
                        </Flex>
                    </Flex>
            </Flex>

        )
    }

    _renderReferences(){
        return(
            <Flex marginTop='20px' column className={style.ReferencesWrapperContainer}>
            <Flex basis='50%' hAlignContent='center'>
            <h1>Er Referens</h1>
            </Flex>
                <Flex style={{marginTop: '20px'}}>
                    <Flex basis='50%' hAlignContent='right'>
                        <Flex column>
                            <H3 marginBottom='5px'> Bolagsnamn</H3>
                            <TextInput placeholder='Bolagsnamn' onChange={this._handleChange} autoComplete='name' value={this.state.referenceName} name='referenceName'/>
                        </Flex>
                    </Flex>
                    <Flex basis='50%' hAlignContent='center'>
                        <Flex column>
                            <H3 marginBottom='5px'> E-post </H3>
                            <TextInput placeholder='E-post' onChange={this._handleChange} autoComplete='email' value={this.state.referenceEmail} name='referenceEmail'/>
                        </Flex>
                    </Flex>
                </Flex>

                <Flex hAlignContent='center' width='50%'>
                </Flex>
            </Flex>

        )
    }
}

function mapStateToProps(state, props){
    const hasInfo = CompanySelectors.getHasBillingInfo(state);
    const companyInfo = CompanySelectors.getCompanyBillingInfo(state);

    return {
        hasInfo: hasInfo,
        isPrivate: companyInfo.get('private_person'),
        companyName: companyInfo.get('name'),
        address: companyInfo.get('address'),
        email: companyInfo.get('email'),
        city: companyInfo.get('city'),
        orgNumber: companyInfo.get('org_nbr'),
        postalCode: companyInfo.get('postal_code'),
        referenceName: companyInfo.get('ref_name'),
        referenceEmail: companyInfo.get('ref_email'),
        period: CompanySelectors.getPaymentPeriod(state)
    };
}

export default connect(mapStateToProps)(CompanyPayment);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/CompanySettings/Payment/index.js